import { useMutation } from "react-query";

import getChartTypeLabelFromId from "utils/chart/getChartTypeLabelFromId";

import { postMultiPhase } from "api/multiProduct";

import { isProductCompatibleWithChartType } from "../components/settings/toggles/presets/Tabs/Products/utils/isProductCompatibleWithChartType";
import { IMultiPhaseInput } from "../models/shared.models";

// TODO: Update  data interface to match the API
// e.g product key is required, not product name
export default function usePostMultiPhase(handlePostData: (postData) => void) {
  const mutation = useMutation(
    "postMultiPhase",
    async (state: IMultiPhaseInput) => {
      const chartType = getChartTypeLabelFromId(state.chartSetting.chartType);
      state.products = state.products.filter((product) =>
        isProductCompatibleWithChartType(chartType, product.name)
      );
      const result = await postMultiPhase(state);
      return result;
    },
    {
      onSuccess: (postData) => {
        handlePostData(postData);
        // Since calculations for the legend width and grid paddings are based on existing chart ref data,
        // We need to recalculate after the chart has been rendered
        handlePostData(postData);
      },
      onError: (err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    }
  );

  return mutation;
}
